import React, { useContext, useEffect } from 'react'
import { FilterWrapper } from '../style';
import { useTranslation } from 'react-i18next';
import { SwissFarmerContext, getSwissFarmersFilters } from '../SwissFarmerProviderComp';
import { useDebounce } from 'use-lodash-debounce';
import { Input } from 'semantic-ui-react';

interface FiltersProps {
  dataFiltered: any
  handleChangeData: (data: any) => void
}

const Filters: React.FC<FiltersProps> = (props) => {
  const { t } = useTranslation()
  const { dataFiltered, handleChangeData } = props
  const {
    contextValues,
    contextValues: {
      filterInputValues
    },
    setContextValues
  } = useContext(SwissFarmerContext)
  const debouncedFilterInputValues = useDebounce(filterInputValues, 300)

  useEffect(() => {
    handleChangeData({ ...dataFiltered, ...debouncedFilterInputValues, page: 0 });
  }, [debouncedFilterInputValues])

  const filters = getSwissFarmersFilters()

  function renderInputFilter(filter) {
    return <Input
      key={filter.key}
      style={{ maxWidth: 200, width: 200 }}
      value={filterInputValues[filter.key]}
      placeholder={t(filter.placeholder)}
      onChange={(e, data) => setContextValues({
        ...contextValues,
        filterInputValues: {
          ...contextValues.filterInputValues,
          [filter.key]: data.value
        }
      })
      }
    />
  }

  return (
    <FilterWrapper>
      {filters.map(filter => renderInputFilter(filter))}
    </FilterWrapper>
  );
}
export default Filters
